export const NEXT_PHASE = 'NEXT_PHASE'
export const GO_TO_PHASE = 'GO_TO_PHASE'
export const GO_TO_PHASE_SUCCESS = 'GO_TO_PHASE_SUCCESS'
export const LOAD_PHASE_SCREENS = 'LOAD_PHASE_SCREENS'
export const NEXT_TURN = 'NEXT_TURN'
export const GAME_LOAD_SUCCESS = 'GAME_LOAD_SUCCESS'
export const GAME_WAITING_SESSION_SUCCESS = 'GAME_WAITING_SESSION_SUCCESS'

export const gameLoadSuccess = (data) => ({
  type: GAME_LOAD_SUCCESS,
  data,
})
export const nextPhase = () => ({
  type: NEXT_PHASE,
})

export const goToPhase = (data) => ({
  type: GO_TO_PHASE,
  data,
})

export const loadPhaseScreens = (data) => ({
  type: LOAD_PHASE_SCREENS,
  data,
})

export const nextTurn = () => ({
  type: NEXT_TURN,
})

export const waitingSessionSuccess = () => ({
  type: GAME_WAITING_SESSION_SUCCESS,
})
